import { Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateProjectMutation,
  useUpdateIntegrationMutation,
} from "../../../redux/slices/projectApiSlice";
import { trackPlatformUsed } from "../../../shared/utils/trackers";
import { platforms } from "../helper";
import {
  ShopifyIntegrationForm,
  WixIntegrationForm,
  WordpressIntegrationForm,
} from "../platforms";

const ProjectIntegrationForm = ({
  platform_name,
  project = null,
  setProject = null,
  integrationData = null,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [createProject, { isLoading: createLoading }] =
    useCreateProjectMutation();
  const [updateIntegration, { isLoading: updateLoading }] =
    useUpdateIntegrationMutation();

  const platform = platforms.find(
    (p) => p.name.toLowerCase() === platform_name
  );

  // Modal for wordpress config
  const [open, setOpen] = useState(integrationData?.seo_plugin ? false : true);

  return (
    <Formik
      initialValues={
        project && integrationData
          ? integrationData
          : platform.integrationInitialValues
      }
      validationSchema={platform.integrationValidationSchema}
      enableReinitialize={true}
      onSubmit={async (values) => {
        if (project) {
          trackPlatformUsed("project", `update_integration`);
          try {
            const res = await updateIntegration({
              platform: platform.name,
              integration_data: values,
              id: project.id,
            }).unwrap();
            toast.success(
              t(
                "modified-project-integration",
                "L'intégration du site web a bien été modifiée !"
              )
            );
            if (platform_name === "wordpress" && open) {
              setOpen(false);
            }
            const updatedProject = {
              ...res.data,
              integration_data: {
                ...res.data.integration_data,
                _updatedAt: new Date().toISOString(),
              },
              _updatedAt: new Date().toISOString(),
            };
            setProject(updatedProject);
          } catch (error) {
            toast.error(
              t(
                "error-linking-project",
                "Une erreur a eu lieu lors de l'intégration du site web !"
              )
            );
          }
        } else {
          trackPlatformUsed("project", `integrate`);
          try {
            console.log({ platform: platform.name, integration_data: values });
            const res = await createProject({
              platform: platform.name,
              integration_data: values,
            }).unwrap();
            if (res.status === 201) {
              if (platform_name === "wordpress") {
                navigate(`/project/${res.data.id}?finalize=true`);
              } else {
                navigate(`/project/${res.data.id}`);
              }
            }
            toast.success(t("created-project", "Le site web a bien été lié !"));
          } catch (error) {
            toast.error(
              t(
                "error-linking-project",
                "Une erreur a eu lieu lors de l'intégration du site web !"
              )
            );
          }
        }
      }}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} method="POST">
          {platform?.name === "WordPress" ? (
            <WordpressIntegrationForm
              props={props}
              createLoading={createLoading}
              platform={platform}
              project={project}
              open={open}
              setOpen={setOpen}
            />
          ) : platform?.name === "Shopify" ? (
            <ShopifyIntegrationForm
              props={props}
              createLoading={createLoading}
              platform={platform}
              project={project}
            />
          ) : (
            platform?.name === "Wix" && (
              <WixIntegrationForm
                props={props}
                createLoading={createLoading}
                platform={platform}
                project={project}
              />
            )
          )}
        </form>
      )}
    </Formik>
  );
};

export default ProjectIntegrationForm;
